import React, { useEffect, useState } from 'react';
import FlightOffers from './Flights/FlightOffers';
import { API_ENDPOINTS, fetchConfig } from './config';
import './App.css';

const APP_VERSION = '0.1.0';

function App() {
  const [loggedIn, setLoggedIn] = useState(null);
  const [userKey, setUserKey] = useState('');
  const [userCode, setUserCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(API_ENDPOINTS.LOGIN, {
      ...fetchConfig,
      method: 'POST',
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setLoggedIn(true);
        } else {
          setLoggedIn(false);
        }
      })
      .catch(() => {
        setLoggedIn(false);
      });
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');

    fetch(API_ENDPOINTS.LOGIN, {
      ...fetchConfig,
      method: 'POST',
      body: JSON.stringify({
        user_key: userKey,
        user_code: userCode
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setLoggedIn(true);
          setError('');
        } else {
          setError(data.message || 'Błędne dane logowania');
        }
      })
      .catch(() => {
        setError('Błąd połączenia z serwerem');
      });
  };

  const handleLogout = () => {
    fetch(API_ENDPOINTS.LOGOUT, {
      ...fetchConfig,
      method: 'POST'
    })
      .then(() => {
        setLoggedIn(false);
        setUserKey('');
        setUserCode('');
      })
      .catch(() => {
        setLoggedIn(false);
      });
  };

  if (loggedIn === null) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner">🔄</div>
        <p className="loading-text">Sprawdzanie logowania...</p>
      </div>
    );
  }

  if (!loggedIn) {
    return (
      <div className="App">
        <div className="login-container">
          <div className="login-card">
            <div className="login-header">
              <div className="login-icon">✈️</div>
              <h1 className="login-title">FlightAlert</h1>
            </div>

            {error && <div className="error-alert">{error}</div>}

            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label htmlFor="userKey" className="form-label">User Key</label>
                <input
                  type="text"
                  id="userKey"
                  className="form-input"
                  value={userKey}
                  onChange={(e) => setUserKey(e.target.value)}
                  required
                  placeholder="Wprowadź swój klucz użytkownika"
                />
              </div>

              <div className="form-group">
                <label htmlFor="userCode" className="form-label">User Code</label>
                <input
                  type="password"
                  id="userCode"
                  className="form-input"
                  value={userCode}
                  onChange={(e) => setUserCode(e.target.value)}
                  required
                  placeholder="Wprowadź swój kod"
                />
              </div>

              <button type="submit" className="login-btn">
                Zaloguj się
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="app-header">
        <div className="header-content">
          <h1 className="offer-title">
            <span>✈️</span>
            <span>FlightAlert</span>
          </h1>
          <button className="logout-btn" onClick={handleLogout}>
            Wyloguj
          </button>
        </div>
      </div>
      <FlightOffers />
      <footer className="app-footer">
        <p>FlightAlert v{APP_VERSION}</p>
      </footer>
    </div>
  );
}

export default App;
